class NoPreviousSteps extends Error {}

export default NoPreviousSteps;
